import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
var ACCESS_TOKEN_REGEX = /([?&]access_token=)[^&]+(&|$)/g;
var PIC_AUTH_REGEX = /([?&]rm=pic_storage_auth&pic=)[^&]+(&|$)/g;
var UUID_REGEX = /[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}/g;
var FILE_ID_AND_UUID_REGEX = new RegExp("[0-9]{3,}-".concat(UUID_REGEX.source), 'g');
var VANITY_NAME_REGEX = /(\/v\/)[^/?]+(\??.+|$)/g;
var BASE64_HASH_REGEX = /[a-fA-F0-9]{64}/g;
var REDACTED = '[redacted]';
export var COMPONENT = 'component';
export var ERROR = 'error';
export var ERROR_MESSAGE = 'error.message';
export var ERROR_OBJECT = 'error.object';
export var TARGET_ELEMENT = 'target_element';
export var decorate = function decorate(attributes) {
  var decorations = {};

  if (attributes[COMPONENT] === ERROR) {
    var _attributes$ERROR_MES, _attributes$ERROR_OBJ;

    var elementName = attributes[TARGET_ELEMENT];
    var defaultMessage = elementName ? "".concat(elementName, " element error") : 'Unknown error';
    decorations[ERROR] = true; // Ensure errors show a red exclamation mark

    decorations[ERROR_MESSAGE] = (_attributes$ERROR_MES = attributes[ERROR_MESSAGE]) !== null && _attributes$ERROR_MES !== void 0 ? _attributes$ERROR_MES : defaultMessage; // Ensure errors are filterable

    decorations[ERROR_OBJECT] = (_attributes$ERROR_OBJ = attributes[ERROR_OBJECT]) !== null && _attributes$ERROR_OBJ !== void 0 ? _attributes$ERROR_OBJ : 'Error'; // Ensure errors are prefixed
  }

  return _objectSpread(_objectSpread({}, attributes), decorations);
};
export var redact = function redact(attributeValue) {
  if (typeof attributeValue === 'string') {
    return attributeValue.replace(ACCESS_TOKEN_REGEX, "$1".concat(REDACTED, "$2")).replace(PIC_AUTH_REGEX, "$1".concat(REDACTED, "$2")).replace(BASE64_HASH_REGEX, REDACTED).replace(FILE_ID_AND_UUID_REGEX, REDACTED).replace(UUID_REGEX, REDACTED).replace(VANITY_NAME_REGEX, "$1".concat(REDACTED, "$2"));
  }

  return attributeValue;
};
export var sanitize = function sanitize(attributes) {
  return Object.keys(attributes).reduce(function (acc, key) {
    acc[key] = redact(attributes[key]);
    return acc;
  }, {});
};
export var serialize = function serialize(attributes) {
  return sanitize(decorate(attributes));
};